@if (current(); as update) {
  <section class="su-panel" [attr.aria-label]="'ADMIN.systemUpdates.whatsNew' | translate">
    <div class="su-panel-head">
      <mat-icon class="su-panel-icon">campaign</mat-icon>
      <span class="su-panel-heading">{{ 'ADMIN.systemUpdates.whatsNew' | translate }}</span>
      @if (total() > 1) {
        <span class="su-panel-position">
          {{ 'ADMIN.systemUpdates.panel.position' | translate: { index: index() + 1, total: total() } }}
        </span>
      }
      <cm-ui-standard-button
        class="su-panel-close"
        icon="close"
        [alt]="'common.close' | translate"
        (onClick)="dismissAll()"
      />
    </div>

    <div class="su-panel-body">
      <div class="su-panel-title">{{ update.title }}</div>
      <app-system-update-body [body]="update.body" />
      <app-system-update-media [mediaUrl]="update.mediaUrl" [thumbnailUrl]="update.mediaThumbnailUrl" [mediaType]="update.mediaType" [title]="update.title" />
    </div>

    <cm-ui-footer>
      <ng-container footer-left>
        <cm-ui-standard-button rounded (onClick)="viewAll()">
          {{ 'ADMIN.systemUpdates.panel.viewAll' | translate }}
        </cm-ui-standard-button>
      </ng-container>
      <ng-container footer-right>
        <cm-ui-standard-button rounded green [disabled]="busy()" (onClick)="next()">
          {{ (isLast() ? 'ADMIN.systemUpdates.panel.gotIt' : 'ADMIN.systemUpdates.panel.next') | translate }}
        </cm-ui-standard-button>
      </ng-container>
    </cm-ui-footer>
  </section>
}
